export default __webpack_public_path__ + "static/media/send-request.f97898ee.svg";